import { render } from "./GrupoList.vue?vue&type=template&id=0f6b9f7c&scoped=true"
import script from "./GrupoList.vue?vue&type=script&lang=js"
export * from "./GrupoList.vue?vue&type=script&lang=js"

import "./GrupoList.vue?vue&type=style&index=0&id=0f6b9f7c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6b9f7c"]])

export default __exports__